import React from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import './landing-page.css'

import LoginForm from './login-form';

export function LandingPage(props) {
    // If we are logged in redirect straight to the user's dashboard
    if (props.loggedIn) {
        return <Redirect to="/dashboard" />;
    }

    return (
        <div className="home col-8">
            <h2>Welcome to CheckMe</h2>
            <div className='intro-paragraph col-6'>CheckMe is a social network of writers and editors. Post a paper to recieve comments and constructive criticism, and edit other people's papers!<br/><br/>DEMO:<br/>username: demo-user<br/>password: password10</div>
            <div className='login-section'>
                <div className='login-label'><Link to="/register">Register</Link> or Log In:</div>
                <LoginForm />
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    loggedIn: state.auth.currentUser !== null
});

export default connect(mapStateToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/landing-page.js